import { render, staticRenderFns } from "./TouchpointOverviewPopup.vue?vue&type=template&id=19a32c5b&scoped=true&"
import script from "./TouchpointOverviewPopup.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointOverviewPopup.vue?vue&type=style&index=0&id=19a32c5b&scoped=true&lang=scss&"
import style1 from "./TouchpointOverviewPopup.vue?vue&type=style&index=1&id=19a32c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a32c5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a32c5b')) {
      api.createRecord('19a32c5b', component.options)
    } else {
      api.reload('19a32c5b', component.options)
    }
    module.hot.accept("./TouchpointOverviewPopup.vue?vue&type=template&id=19a32c5b&scoped=true&", function () {
      api.rerender('19a32c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointOverviewPopup.vue"
export default component.exports